export enum EFormDataNames {
  CounterpartyGuid = 'counterparty_guid',
  Intention = 'intention',
  Payload = 'payload',
  RoleName = 'role_name',
}

export enum ERoleSearchParamsKey {
  CounterpartyGuid = 'counterparty_guid',
}

export enum EUserManagementRolesPageGetParams {
  Action = 'action',
}

export enum EUserManagementRolesPageGetParamsActionTypes {
  Create = 'create',
}
